import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { monitoringSearchDetailsQuery } from '@/core/queries';
import { monitoringStore } from '@/core/stores';

interface UseMonitoringHitsParams {
	graphId: number;
}

export const useMonitoringHits = ({ graphId }: UseMonitoringHitsParams) => {
	const prefetchQuery = useQuery({
		queryKey: ['searchDetails', graphId, 'prefetch'],
		queryFn: () =>
			monitoringSearchDetailsQuery({
				graphNodeId: graphId,
				page: 1,
				limit: 1,
			}),
		staleTime: Infinity,
	});

	const totalHits = prefetchQuery.data?.matchInfo?.totalHits ?? 0;

	const query = useQuery({
		queryKey: ['searchDetails', graphId, totalHits],
		queryFn: () =>
			monitoringSearchDetailsQuery({
				graphNodeId: graphId,
				page: 1,
				limit: totalHits,
			}),
		staleTime: Infinity,
		enabled: totalHits > 0,
	});

	useEffect(() => {
		if (query.data) {
			// @ts-expect-error FIXME TS error is suppressed for migration, fix it later
			const hits = query.data.matches.map((item) => item.rawResponse.hit);

			monitoringStore.assign({
				hits: hits,
				searchInfo: query.data.searchInfo,
			});
		}
	}, [query.data]);

	return query;
};
